module.exports = __webpack_public_path__ + "media/images/menu/indus-d4034f73f4c45ccb74564ac53ec5ff88.jpg";